import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageContent from '../../../components/Redesing/page-content';
import PageContainer from '../../../components/Redesing/page-container';
import { changeTab } from '../../../utils';
import GeneralTab from './general-tab';
import OrganizationAdmins from './organization-admins';

function OrganizationSettingsIndex() {
  let { currentTab = 'general' } = useParams<{ currentTab: string }>();
  const [currentTabV, setCurrentTabV] = useState(currentTab);

  const handleTabsChange = useCallback(
    (event: React.SyntheticEvent, value: React.SetStateAction<string>) => {
      changeTab(value, currentTab, 'settings');
    },
    [currentTab]
  );

  useEffect(() => {
    if (currentTab !== currentTabV) {
      setCurrentTabV(currentTab);
    }
  }, [currentTab, currentTabV]);

  return (
    <PageContainer spaceName={'Settings'}>
      <PageContent
        detailedView={false}
        currentTabV={currentTabV}
        handleTabsChange={handleTabsChange}
        tabsList={[
          { label: 'General', value: 'general' },
          { label: 'Admins', value: 'admin' },
        ]}
        tabsChildren={
          <>
            {currentTabV === 'general' && <GeneralTab />}
            {currentTabV === 'admin' && <OrganizationAdmins />}
          </>
        }
      />
    </PageContainer>
  );
}

export default OrganizationSettingsIndex;
